<template>
  <div class="p-0 message-wrapper" v-if="message.text">
    <div class="message" v-if="!message.isAction">
      <p v-html="formatTextMentions(message.text) || ''"></p>
      <img
        @click="openEditorToEditMessage()"
        class="edit-button mr-2"
        src="../../icons/dod/edit_message.svg"
        alt=""
      />
      <img
        @click="deleteMessage(message.id)"
        class="remove-button"
        src="../../icons/dod/trash.svg"
        alt=""
      />

      <div
        class="mt-4 p-0 message-attachment"
        v-for="attachment in message.attachments"
        :key="attachment.id"
      >
        <svg
          @click="downloadAttachment(attachment)"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="cursor-pointer"
        >
          <path
            d="M23.0894 6.08047L22.5877 6.63794V6.63794L23.0894 6.08047ZM29.0276 11.4248L28.5259 11.9823L29.0276 11.4248ZM32.481 15.2311L31.7959 15.5363V15.5363L32.481 15.2311ZM4.75736 31.2426L5.28769 30.7123H5.28769L4.75736 31.2426ZM31.2426 31.2426L30.7123 30.7123L30.7123 30.7123L31.2426 31.2426ZM21 32.25H15V33.75H21V32.25ZM3.75 21V15H2.25V21H3.75ZM32.25 20.3443V21H33.75V20.3443H32.25ZM22.5877 6.63794L28.5259 11.9823L29.5293 10.8673L23.5911 5.523L22.5877 6.63794ZM33.75 20.3443C33.75 17.7787 33.7651 16.271 33.1661 14.926L31.7959 15.5363C32.2349 16.522 32.25 17.6462 32.25 20.3443H33.75ZM28.5259 11.9823C30.5314 13.7873 31.3569 14.5506 31.7959 15.5363L33.1661 14.926C32.5671 13.581 31.4363 12.5837 29.5293 10.8673L28.5259 11.9823ZM15.0447 3.75C17.389 3.75 18.3672 3.76158 19.2451 4.09849L19.7825 2.69806C18.5847 2.23842 17.2754 2.25 15.0447 2.25V3.75ZM23.5911 5.523C21.9412 4.03807 20.9802 3.15766 19.7825 2.69806L19.2451 4.09849C20.1232 4.43545 20.854 5.07765 22.5877 6.63794L23.5911 5.523ZM15 32.25C12.1504 32.25 10.0886 32.2484 8.5163 32.037C6.96559 31.8285 6.00379 31.4284 5.28769 30.7123L4.22703 31.773C5.26829 32.8142 6.59938 33.2928 8.31643 33.5236C10.0119 33.7516 12.1928 33.75 15 33.75V32.25ZM2.25 21C2.25 23.8072 2.24841 25.9881 2.47636 27.6836C2.70721 29.4006 3.18577 30.7317 4.22703 31.773L5.28769 30.7123C4.57159 29.9962 4.17147 29.0344 3.96298 27.4837C3.75159 25.9114 3.75 23.8496 3.75 21H2.25ZM21 33.75C23.8072 33.75 25.9881 33.7516 27.6836 33.5236C29.4006 33.2928 30.7317 32.8142 31.773 31.773L30.7123 30.7123C29.9962 31.4284 29.0344 31.8285 27.4837 32.037C25.9114 32.2484 23.8496 32.25 21 32.25V33.75ZM32.25 21C32.25 23.8496 32.2484 25.9114 32.037 27.4837C31.8285 29.0344 31.4284 29.9962 30.7123 30.7123L31.773 31.773C32.8142 30.7317 33.2928 29.4006 33.5236 27.6836C33.7516 25.9881 33.75 23.8072 33.75 21H32.25ZM3.75 15C3.75 12.1504 3.75159 10.0886 3.96298 8.5163C4.17147 6.96559 4.57159 6.00379 5.28769 5.28769L4.22703 4.22703C3.18577 5.26829 2.70721 6.59938 2.47636 8.31643C2.24841 10.0119 2.25 12.1928 2.25 15H3.75ZM15.0447 2.25C12.2225 2.25 10.0307 2.24842 8.32805 2.4763C6.60439 2.70699 5.26887 3.18519 4.22703 4.22703L5.28769 5.28769C6.00321 4.57217 6.96803 4.17169 8.52703 3.96304C10.107 3.75158 12.1802 3.75 15.0447 3.75V2.25Z"
            fill="#1C274C"
          />
          <path
            d="M19.5 3.75V7.5C19.5 11.0355 19.5 12.8033 20.5983 13.9017C21.6967 15 23.4645 15 27 15H33"
            stroke="#1C274C"
            stroke-width="1.5"
          />
          <path
            d="M9 24L16.5 24M16.5 24L13.6875 21M16.5 24L13.6875 27"
            stroke="#1C274C"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <p
          @click="downloadAttachment(attachment)"
          class="cursor-pointer mb-0 pt-3 ml-2"
        >
          {{ attachment.originalName }}
        </p>

        <svg
          class="cursor-pointer mt-3 ml-3"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="removeAttachment(attachment.id)"
        >
          <circle cx="12" cy="12" r="10" stroke="#EC0909" stroke-width="1.5" />
          <path
            d="M14.5 9.5L9.5 14.5M9.49998 9.49998L14.5 14.5"
            stroke="#EC0909"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
    <div v-if="editing" class="editing-container">
      <html-editor-with-mentions
        :editorId="`editDodMessageEditor${message.id}`"
        @contentchanged="handleHtmlEditorContent($event)"
        :withoutAllReplacements="true"
        :startContent="message.text"
      />

      <gradient-button
        @handleClick="editMessage()"
        :title="'Zapisz'"
        :customStyles="'width: 100%; height: 40px; max-height: 40px;font-size: 15px'"
      />
    </div>

    <div v-if="!message.isAction" class="small-message">
      <span>{{ message.admin ? `${message.admin}: ` : "User: " }}</span>
      <span>{{ messageDate || "" }}</span>
    </div>
    <div v-if="message.isAction" class="small-message">
      <span>{{ messageDate || "" }} </span>
      <span>{{ message.text || "" }}</span>
    </div>
  </div>
</template>

<script>
import HtmlEditorWithMentions from "../HtmlEditorWithMentions.vue";
import GradientButton from "./GradientButton.vue";
export default {
  components: { GradientButton, HtmlEditorWithMentions },
  props: ["message"],
  emits: ["messageDeleted", "editMessage"],
  data() {
    return {
      messageDate: "",
      editing: false,
      newMessageAfterEdit: "",
    };
  },
  mounted() {
    this.messageDate = new Intl.DateTimeFormat("pl-PL", {
      weekday: "long",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(this.message.createdAt));
  },
  methods: {
    async downloadAttachment(attachment) {
      const response = await this.$store.dispatch(
        "getDodFileBlob",
        attachment.id
      );

      const fileURL = window.URL.createObjectURL(new Blob([response]));
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", attachment.originalName);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    async removeAttachment(attachmentId) {
      if (confirm(`Czy na pewno chcesz usunąć załącznik?`)) {
        this.$emit("attachmentRemoved", attachmentId);
        await this.$store.dispatch("removeDodFile", attachmentId);
      }
    },
    handleHtmlEditorContent(content) {
      this.newMessageAfterEdit = content;
    },
    openEditorToEditMessage() {
      this.newMessageAfterEdit = this.message.text;
      this.editing = !this.editing;
    },
    formatTextMentions(text) {
      return text.replace(/@(\w+)/g, "<b>@$1</b>");
    },
    deleteMessage(messageId) {
      if (confirm(` Czy na pewno chcesz usunąć wiadomość?`)) {
        this.handleEmitMessageDeleted(messageId);
      }
    },

    editMessage() {
      if (this.newMessageAfterEdit === "") {
        this.$notify({
          group: "error",
          text: "Wiadomośc nie może być pusta ",
        });
        return;
      }
      this.$emit("editMessage", {
        messageId: this.message.id,
        text: this.newMessageAfterEdit,
      });
      this.editing = false;
    },
    handleEmitMessageDeleted(messageId) {
      this.$emit("messageDeleted", messageId);
    },
  },
};
</script>

<style scoped>
.message-wrapper {
  margin-bottom: 10px;
}
.message {
  background-color: #f1e2ef;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 12px;
  padding: 10px;
  padding-right: 40px;
  color: #090741;
  font-size: 15px;
  white-space: pre-line;
  position: relative;
  vertical-align: middle;
}
.small-message {
  font-size: 15px;
  color: #c1c1cf;
  text-align: right;
  font-weight: 300;
}
.remove-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  cursor: pointer;
}
.edit-button {
  position: absolute;
  top: 10px;
  right: 30px;
  width: 20px;
  cursor: pointer;
}
.message-attachment {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
</style>
